import { isAudioDataEmpty, Waveform as WaveformType } from '@mi-front/core';
import * as d3 from 'd3';
import WaveformData from 'waveform-data';
import { theme } from '../../../../styles';
import { waveformMock } from '../mock/waveform-mock';

WaveformPath.defaultProps = {
  fill: theme.blue,
};

interface Props {
  readonly waveform: WaveformType;
  readonly x: number;
  readonly width: number;
  readonly height: number;
  readonly fill: string;
  readonly ts?: number;
}

export function WaveformPath(p: Props) {
  const { waveform, width, height, fill } = p;

  if (width <= 0) return null;

  let path;

  try {
    path = getPath({
      waveform,
      height,
      width,
    });
  } catch {
    path = getPath({ waveform: waveformMock, height, width });
  }

  if (!path) {
    throw new Error('No path generated from waveform');
  }

  return <path d={path} fill={fill} />;
}

function getPath(args: { waveform: WaveformType; width: number; height: number }) {
  const { waveform, width, height } = args;

  if (!waveform) {
    throw new Error(`Empty waveform data found`);
  }

  if (isAudioDataEmpty(waveform.data)) {
    return null;
  }

  // Obtain the generated segment waveform and then draw it
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let wave: any;

  // eslint-disable-next-line no-useless-catch
  try {
    // TODO: using +XXX to avoid blank lines between misaligned segments
    const w = WaveformData.create(waveform);
    if (w.adapter.data.samples_per_pixel > 441) {
      wave = w.resample(width + 2);
    } else {
      wave = w;
    }
  } catch (error) {
    throw error;
  }

  const scaleY = d3
    .scaleLinear()
    .domain([-128, 128])
    .rangeRound([-(height / 2), height / 2]);

  const wavearea = d3
    .area()
    .x((_d, i) => i)
    .y0((_d, i) => scaleY(wave.min[i])!)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .y1((d: any) => scaleY(d)!);

  return wavearea(wave.max);
}
